/**
 * @override King Living — Full GlobalConfig with My Account landing nested entries.
 */

import gql from 'graphql-tag';

import {AccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/accordion-panel.fragment';
import {BlogRelatedArticlesFragment} from '@amblique/contentful/app/contentful/fragments/blog-related-articles/blog-related-articles.fragment';
import {BaseGlobalConfigFragment} from '@amblique/contentful/app/contentful/fragments/global-config/base-global-config.fragment';
import {HeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/hero-banner.fragment';
import {IconFragment} from '@amblique/contentful/app/contentful/fragments/icon/icon.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';
import {ProductTilesFragment} from '@amblique/contentful/app/contentful/fragments/product-tiles/product-tiles.fragment';

export const FullGlobalConfigFragment = gql`
  ${AccordionPanelFragment}
  ${BaseGlobalConfigFragment}
  ${HeroBannerFragment}
  ${IconFragment}
  ${ImageFragment}
  ${LinkFragment}
  ${ProductTilesFragment}
  ${BlogRelatedArticlesFragment}

  fragment FullGlobalConfigFragment on GlobalConfig {
    ...BaseGlobalConfigFragment

    accountHero {
      ...HeroBannerFragment
    }
    accountSuggestedForYou {
      ...ProductTilesFragment
    }
    accountGetInspired {
      ...BlogRelatedArticlesFragment
    }
    accountOrderHistoryFaq {
      ...AccordionPanelFragment
    }
    accountShopNowLink {
      ...LinkFragment
    }
    cartPaymentIconsCollection {
      items {
        __typename
        ... on Icon {
          ...IconFragment
        }
      }
    }
    cartPaymentIconsCursorCollection {
      items {
        __typename
        ... on Icon {
          ...IconFragment
        }
      }
    }
    loginImage {
      ...ImageFragment
    }
    showroomHero {
      ...HeroBannerFragment
    }
    signUpImage {
      ...ImageFragment
    }
    socialLinksCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
    socialLinksCursorCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
  }
`;
